webpackJsonp([46],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(588);
	module.exports = __webpack_require__(979);


/***/ },

/***/ 979:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(10)['default'];
	
	var _jquery = __webpack_require__(9);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	(0, _jquery2['default'])(function () {
	    (0, _jquery2['default'])('.pcd-select').on('change', function (e) {
	        var $this = (0, _jquery2['default'])(this),
	            val = '',
	            $target = $this.closest('.pcd-block').find('.pcd-value');
	        if ($this.val()) {
	            val = $this.val() + ' mm.';
	        }
	        $target.text(val);
	    });
	});

/***/ }

});


/** WEBPACK FOOTER **
 ** webshop/info.a6c5ebda5d1b84878f9a.js
 **/